<template>
    <main class="custom-compete-page-wrapper">
        <CompeteHeader v-if="l10n.competeHeader" v-bind="l10n.competeHeader" />
        <STablesNew v-if="l10n.differencesTable" class="s-tables-new" v-bind="l10n.differencesTable" />
        <SG2Reviews v-if="l10n.g2Reviews" v-bind="l10n.g2Reviews" />
        <SValueCards v-if="l10n.valueCards" v-bind="l10n.valueCards" />
        <STablesNew v-if="l10n.comparisonTable" class="s-tables-new" v-bind="l10n.comparisonTable" />
        <SMessageHighlights v-if="l10n.messageHighlights" v-bind="l10n.messageHighlights" />
        <SAwards v-if="l10n.awards" v-bind="l10n.awards" />
        <SResourceHighlight v-if="l10n.resourceHighlight" v-bind="l10n.resourceHighlight" />
        <EasySteps v-if="l10n.easySteps" v-bind="l10n.easySteps" />
        <STrialForm v-if="l10n.trialForm" v-bind="l10n.trialForm" />
        <SFAQ v-if="l10n.faq" v-bind="l10n.faq" />
    </main>
</template>

<script>
import contentMixin from '@core/mixins/content.js';
import l10n from '@core/mixins/l10n.js';
import styleMixin from '@core/mixins/style.js';
import SAwards from '@core/slices/pages/awards/awards.vue';
import SFAQ from '@core/slices/pages/faq/faq.vue';
import SG2Reviews from '@core/slices/pages/g2-reviews/g2-reviews.vue';
import SMessageHighlights from '@core/slices/pages/message-highlights/message-highlights.vue';
import SResourceHighlight from '@core/slices/pages/resource-highlight/resource-highlight.vue';
import STablesNew from '@core/slices/pages/tables-new/tables-new.vue';
import STrialForm from '@core/slices/pages/trial-form/trial-form.vue';
import SValueCards from '@core/slices/pages/value-cards/value-cards.vue';
import CompeteHeader from './components/compete-header.vue';
import EasySteps from './components/easy-steps.vue';

export default {
    components: {
        CompeteHeader,
        SValueCards,
        SMessageHighlights,
        SG2Reviews,
        STrialForm,
        STablesNew,
        SResourceHighlight,
        SAwards,
        SFAQ,
        EasySteps,
    },
    mixins: [l10n, contentMixin, styleMixin],
    props: {
        competeHeader: {
            type: Object,
            default() {},
        },
        g2Reviews: {
            type: Object,
            default() {},
        },
        valueCards: {
            type: Object,
            default() {},
        },
        differencesTable: {
            type: Object,
            default() {},
        },
        comparisonTable: {
            type: Object,
            default() {},
        },
        messageHighlights: {
            type: Object,
            default() {},
        },
        resourceHighlight: {
            type: Object,
            default() {},
        },
        trialForm: {
            type: Object,
            default() {},
        },
    },
};
</script>

<style lang="postcss" scoped>
.s-tables-new {
    &:deep(.a-slice-header) {
        width: 100%;
        margin-bottom: 40px;
    }

    &:deep(.a-table__glyph) {
        margin-inline: auto;
    }

    &:deep(.a-table__description) {
        margin-top: 0;
        padding-inline-start: 0;
    }
}

.s-values {
    &.s-slice_background {
        @mixin background;

        &_light-blue {
            background: var(--av-solid-brand-lightest);
        }
    }

    &:deep(.a-slice-header) {
        width: 100%;
        text-align: center;
        margin-bottom: 40px;
    }

    &:deep(.s-values__item) {
        border-radius: 24px;
        text-align: center;
        box-shadow: var(--av-shadow-small);

        @media (--viewport-desktop) {
            width: calc(50% - 16px);
        }

        &:after {
            border-radius: 24px;
        }
    }

    &:deep(.a-value-card__title) {
        @mixin lead-accent;

        @media (--viewport-desktop) {
            @mixin title;
        }
    }

    &:deep(.a-picture__img) {
        object-fit: contain;
    }

    &:deep(.a-value-card) {
        border-radius: 24px;
    }
}

.s-g2-reviews.compact {
    &:deep(.header-wrapper) {
        border-radius: 24px;

        @media (--viewport-desktop-wide) {
            border-radius: 56px;
        }
    }
}
.s-message-highlights {
    &.s-slice_background {
        @mixin background;

        &_light-blue {
            background: var(--av-solid-brand-lightest);
        }
    }

    &:deep(.s-message-highlights__img-container) {
        @media (--viewport-desktop) {
            @mixin colls 6;
        }
    }

    &:deep(.a-slice-header__title) {
        @mixin display-accent;

        @media (--viewport-tablet) {
            @mixin hero-accent;
        }
    }

    &:deep(.a-slice-header__lead) {
        @mixin lead;
    }
}

.s-awards {
    &:deep(.a-slice-header) {
        width: 100%;
        text-align: center;
        margin-bottom: 40px;
    }
}

.s-resource-highlight {
    &.s-slice_background {
        @mixin background;

        &_light-blue {
            background: var(--av-solid-brand-lightest);
        }
    }

    &:deep(.s-resource-highlight__header__content__title) {
        @mixin hero-accent;
        margin-bottom: 0;
    }

    &:deep(.a-resource-highlight-card) {
        overflow: hidden;
        border-radius: 24px;
        width: 100%;
    }
}

.s-form {
    @mixin basic-slice-paddings;

    &.s-slice_background {
        @mixin background;

        &_light-blue {
            background: var(--av-solid-brand-lightest);
        }
    }

    &:deep(.s-info) {
        display: flex;
        align-items: center;

        .title {
            @mixin display-accent;

            @media (--viewport-tablet) {
                @mixin hero-accent;
            }
        }

        .subtitle {
            @mixin title;
            font-weight: 400;
            color: var(--av-nav-primary);
            margin-top: 24px;

            @media (--viewport-tablet) {
                @mixin display;
            }
        }
    }

    &:deep(.s-info-blocks-container ~ .s-form-container .s-form-registration) {
        padding: 32px;
        border-width: 2px;
        border-radius: 16px;
        box-shadow: 0px 10px 20px 0px rgba(36, 49, 67, 0.20);
    }

    &:deep(.s-form-registration__button) {
        border-radius: 12px;
    }

    @media (max-width: 1023px) {
        &:deep(.s-form__wrapper-blocks) {
            flex-wrap: wrap;
            gap: 32px;
        }

        &:deep(.s-info-blocks-container) {
            max-width: none;
            width: auto;
        }

        &:deep(.s-info-blocks-container ~ .s-form-container) {
            width: auto;
            max-width: 584px;
            margin-inline: auto;
        }
    }
}
</style>
